export function requireAll(r) {
  r.keys().forEach(r);
}
